export var KEY = {
    ESCAPE: 27,
    BACKSPACE: 8,
    TAB: 9,
    ENTER: 13,
    UP: 38,
    DOWN: 40,
};
//# sourceMappingURL=index.js.map